import {
  DisclosuresParamsTypes,
  DisclosuresTypes,
  DisclosuresCurrentCateType,
} from './types';

import axiosInstance from 'services/common/instance';

const getDisclosuresDetailService = async (slug: string): Promise<DisclosuresTypes> => {
  const response = await axiosInstance.get(`disclosures/${slug}`);
  return response.data.data;
};

export const getDisclosuresService = async (
  params: DisclosuresParamsTypes,
): Promise<PaginationData<DisclosuresTypes[]>> => {
  const response = await axiosInstance.get('disclosures', { params });
  return response.data;
};

export const getDisclosuresCurrentCateService = async (
  slug: string,
): Promise<DisclosuresCurrentCateType> => {
  const response = await axiosInstance.get(`disclosure-categories/${slug}`);
  return response.data.data;
};

export default getDisclosuresDetailService;
